<script setup lang="ts">

const props = defineProps<{ token: string, amount: string, index: number, side: string }>();
</script>

<template>
  <div class="history-item-container">
    <div class="history-item-icon">
      <img v-bind:src="'/crypto-icons/'+props.token.toLowerCase()+'.svg'" class="alice-crypto-icon-small"/>
    </div>
    <div class="history-item-right">
      <div :id="'history-item-' + props.index + '-' + props.side" class="history-item-token">{{ props.token }}</div>
      <div :id="'history-item-' + props.index + '-' + props.side + '-trade-value'" class="history-item-amount">{{ props.amount }}</div>
    </div>
  </div>
</template>

<style scoped>
.history-item-container {
  display: flex;
}

.history-item-icon {
  display: inline;
  margin-right: 10px;
}

.history-item-right {
  display: inline;
}

.history-item-token {
  display: block;
  font-family: WorkSans;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f1f;
}

.history-item-amount {
  display: block;
  font-family: WorkSans;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1f1f1f;
}

.alice-crypto-icon-small {
  height: 36px;
}
</style>